<script>
import { VTabs } from 'vuetify/lib'
import ETabsBar from './ETabsBar.vue'

export default {
  name: 'ETabs',
  extends: VTabs,
  props: {
    height: {
      type: Number,
      default: 34,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'e-tabs': true,
        'v-tabs--align-with-title': this.alignWithTitle,
        'v-tabs--small': this.small,
        'v-tabs--large': this.large,
        'v-tabs--centered': this.centered,
        'v-tabs--fixed-tabs': this.fixedTabs,
        'v-tabs--grow': this.grow,
        'v-tabs--icons-and-text': this.iconsAndText,
        'v-tabs--right': this.right,
        'v-tabs--vertical': this.vertical,
        ...this.themeClasses,
      }
    },
  },
  methods: {
    genBar(items, slider) {
      const data = {
        props: {
          activeClass: this.activeClass,
          centerActive: this.centerActive,
          dark: this.dark,
          light: this.light,
          mandatory: !this.optional,
          mobileBreakpoint: this.mobileBreakpoint,
          nextIcon: this.nextIcon,
          prevIcon: this.prevIcon,
          showArrows: this.showArrows,
          value: this.internalValue,
        },
        on: {
          'call:slider': this.callSlider,
          change: (val) => {
            this.internalValue = val
          },
        },
        ref: 'items',
      }
      this.setTextColor(this.computedColor, data)
      this.setBackgroundColor(this.backgroundColor, data)
      return this.$createElement(ETabsBar, data, [this.genSlider(slider), items])
    },
  },
  watch: {
    small: 'callSlider',
    large: 'callSlider',
    alignWithTitle: 'callSlider',
    centered: 'callSlider',
    centerActive: 'callSlider',
    fixedTabs: 'callSlider',
    grow: 'callSlider',
    iconsAndText: 'callSlider',
    right: 'callSlider',
    showArrows: 'callSlider',
    vertical: 'callSlider',
    '$vuetify.application.left': 'onResize',
    '$vuetify.application.right': 'onResize',
    '$vuetify.rtl': 'onResize',
  },
}
</script>
